(() => {
  const variantIds = new Set(['67889881415997', '67878110986557', '67889881448765']);

  function updateProductForms(root, variantId) {
    const productInfo = root.closest('product-info');
    const scope = productInfo || document;
    const inputs = [...scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]')];

    for (const input of inputs) {
      if (!variantIds.has(String(input.value)) && productInfo) continue;
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!inputs.length || !inputs.some((input) => String(input.value) === variantId)) {
      for (const input of document.querySelectorAll('form[action*="/cart/add"] input[name="id"]')) {
        if (!variantIds.has(String(input.value))) continue;
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateGallery(root, mediaId) {
    const productInfo = root.closest('product-info');
    const gallery = productInfo?.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery) return;

    const slide = gallery.querySelector(`[data-media-id$="-${mediaId}"]`);
    const target = slide?.dataset.mediaId;
    if (!target) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(target, true);
      return;
    }

    const thumbnail = gallery.querySelector(`[data-target="${target}"] button`);
    if (thumbnail) thumbnail.click();
  }

  function setVariant(root, input, updateUrl = true) {
    const variantId = String(input.dataset.variantId || '');
    const mediaId = String(input.dataset.mediaId || '');
    if (!variantIds.has(variantId)) return;

    input.checked = true;
    const selectedLabel = root.querySelector('[data-oc-giraffe-selected-label]');
    if (selectedLabel) selectedLabel.textContent = input.value;

    updateProductForms(root, variantId);
    updateGallery(root, mediaId);

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    document.dispatchEvent(new CustomEvent('afterVariantChanged', {
      detail: { sectionId: root.dataset.section, variantId }
    }));
  }

  function initialize(root) {
    if (root.dataset.ocGiraffeReady === 'true') return;
    root.dataset.ocGiraffeReady = 'true';

    const choices = [...root.querySelectorAll('[data-oc-giraffe-choice]')];
    if (choices.length !== 3) return;

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-oc-giraffe-choice]')) return;
      setVariant(root, event.target, true);
    });

    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    const initial = choices.find((choice) => String(choice.dataset.variantId) === urlVariant)
      || choices.find((choice) => choice.checked)
      || choices[0];
    setVariant(root, initial, false);
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-oc-giraffe-selector]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
